import React from 'react';
import type { PriceStatus } from '@/lib/claimStore';

interface StatusBadgeProps {
  status: PriceStatus;
  size?: 'sm' | 'md';
}

const STATUS_CONFIG: Record<PriceStatus, { label: string; classes: string }> = {
  unpriced: {
    label: 'Unpriced',
    classes: 'bg-negative-bg text-negative border border-negative/20',
  },
  researching: {
    label: 'Researching…',
    classes: 'bg-warning-bg text-warning border border-warning/20',
  },
  priced: {
    label: 'Priced',
    classes: 'bg-info-bg text-info border border-info/20',
  },
  price_researched: {
    label: 'Price Researched',
    classes: 'bg-purple-100 text-purple-700 border border-purple-200 dark:bg-purple-900/30 dark:text-purple-300 dark:border-purple-700/40',
  },
  verified: {
    label: 'Verified',
    classes: 'bg-positive-bg text-positive border border-positive/20',
  },
};

export default function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG['unpriced'];
  return (
    <span
      className={[
        'inline-flex items-center rounded-full font-medium',
        size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-xs px-2.5 py-1',
        config.classes,
      ].join(' ')}
    >
      {config.label}
    </span>
  );
}